/**
 * Mixins for Log Time Functions
 */
import moment from 'moment'
require('moment-duration-format')

export const mixin = {
  methods: {
    logTimeInSeconds (log) {
      // A single Log's total time in seconds
      if (log.start) {
        // Find the log time by diffing the end and start date, less the pausetime
        let diff = moment.utc(log.end || new Date()).diff(moment.utc(log.start), 's')
        return moment.duration(diff, 's').subtract(log.pausetime, 's').asSeconds()
      } else {
        return 0
      }
    },
    totalLogTimeInSeconds (logs) {
      // The collective seconds of an Array of logs
      var total = 0
      for (var key in logs) {
        total += this.logTimeInSeconds(logs[key])
      }
      return total
    },

    logAsTime (log) {
      // A single log's seconds formatted as a time string
      return this.secondsToTime(this.logTimeInSeconds(log))
    },

    logsAsTime (logs) {
      // A and Array of log second's formatted as a time string
      return this.secondsToTime(this.totalLogTimeInSeconds(logs))
    },

    secondsToTime (seconds) {
      return moment.duration(seconds, 's').format({template: 'hh:mm', trim: false})
    },

    dateTimeToHoursMinutes (dateTime) {
      // Convert a date time to just 48 hour Hours Minutes (strip away all other date stuff)
      return moment.utc(dateTime).local().format('HH:mm')
    },

    dateTimeToDate (dateTime) {
      // Convert a date time to just a date (strip away all time)
      return moment.utc(dateTime).local().format('DD/MM/YYYY')
    },

    logDateTime (log) {
      // Return the date of the log formatted
      return moment.utc(log.end).local().format('D/M/YY h:mma')
    },

    logDate (log) {
      // Return the date of the log formatted
      return moment.utc(log.end).local().format('D/M/YY')
    },

    logTime (log) {
      // Return the date of the log formatted
      return moment.utc(log.end).local().format('h:mma')
    }
  }
}

